import React, { useEffect, useMemo, useState } from 'react';
import { Redirect, RouteProps, useLocation } from 'react-router-dom';
import { ROOT } from '../../config/routes/paths';
import { IEventCustomSettings, useCustomSettings } from '../../hooks/use-custom-settings';
import { useEventPublicInfo } from '../../hooks/api/public/use-event-public-details';
import RegistrationWrapper from './RegistrationWrapper/RegistrationWrapper';
import { IAuthContext, useAuth } from "../../lib/context-providers/auth-context";
import { useHistory } from "react-router-dom";
import { LoadingPage } from './LoadingPage';
import { usePathPrefix } from '../../hooks/use-path-prefix';
import { normalizeRoutePath } from '../../lib/helpers/urlHelper';
import { CODE, STATE, TOKEN } from '../../lib/constants';

export const RegistrationPage: React.FC<RouteProps> = (props: RouteProps): JSX.Element | null => {
  const { registrationEnabled } = useCustomSettings() as IEventCustomSettings;
  const { data } = useEventPublicInfo();
  const auth = useAuth() as IAuthContext;
  const pathPrefix = usePathPrefix();

  const history = useHistory();
  const { state, search } = useLocation<{ from?: string; errorMsg?: string; email?: string }>();
  const searchParams = useMemo(() => new URLSearchParams(search), [search]);
  const selectedTriageAnswer = searchParams.get('formName');
  const token = searchParams.get(TOKEN);
  const code = searchParams.get(CODE);
  const userState = searchParams.get(STATE);
  const [storedQueryParams, setStoredQueryParams] = useState<Record<string, string>>({});

  useEffect(() => {
    localStorage.removeItem('query_params');
    const filteredParams: Record<string, string> = {};
    for (const [key, value] of searchParams) {
      if (!(key in filteredParams) && value) {
        filteredParams[key] = value;
      }
    }
    if (Object.keys(filteredParams).length > 0) {
      localStorage.setItem('query_params', JSON.stringify(filteredParams));
      setStoredQueryParams(filteredParams);
      window.history.replaceState({}, document.title, window.location.pathname + window.location.hash);
    }
  }, [searchParams]);
  const handleSignIn = async (email: string, code: string) => {
    const isAuthenticated = await auth.signIn(email, code, data?.attendeeSsoEnabled ?? false);
    if (state?.from && isAuthenticated) {
      history.replace(state.from);
    }
  };

  if (token || (code && userState)) {
    return <LoadingPage token={token} code={code} userState={userState} />;
  }

  if (data && registrationEnabled) return (
    <RegistrationWrapper
      data={data}
      signIn={(email, code) => handleSignIn(email, code)}
      location={state}
      selectedTriageAnswer={selectedTriageAnswer || ''}
      urlParams={storedQueryParams}
    />
  );
  if (registrationEnabled === false) return <Redirect to={normalizeRoutePath(ROOT, pathPrefix)} />;

  return null;
};

